import React from "react";
import { SHTypography } from "@components/design-systems";
import { SHTextOverflowTooltip } from "@components/design-systems/sh-text-overflow-tooltip";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";

export const MSTableDefaultStickyCell = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    return (
      <SHTextOverflowTooltip tooltipContent={cellData.value}>
        <SHTypography variant={"body1"} fontSize={13} lineHeight={1.2}>
          {cellData.value}
        </SHTypography>
      </SHTextOverflowTooltip>
    );
  },
);
